import { Typography } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';

export default function StacksList() {
  return (
    <main
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        padding: '1rem',
        width: '100%',
        height: '100%',
        overflowY: 'auto',
      }}
    >
      <header>
        <Typography variant='h5' component='h1'>
          Stacks
        </Typography>
      </header>
      <section
        style={{
          marginTop: '2rem',
        }}
      >
        <DataGridPro columns={[]} />
      </section>
    </main>
  );
}
